var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMusicNote2 = function SvgMusicNote2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78852 8.02981C9.77556 8.01994 9.76272 8.00991 9.75 7.99973V8.03943L9.78852 8.02981ZM20.25 6.9606V12.9997C19.6233 12.529 18.8442 12.25 18 12.25C15.9289 12.25 14.25 13.9289 14.25 16C14.25 18.0711 15.9289 19.75 18 19.75C20.0711 19.75 21.75 18.0711 21.75 16V6.00002V5.96669C21.75 5.32388 21.75 4.79359 21.7134 4.36753C21.6757 3.92858 21.5942 3.51638 21.378 3.14409C21.0289 2.5429 20.4649 2.09627 19.7998 1.89409C19.3878 1.76888 18.9679 1.78396 18.532 1.8478C18.1089 1.90977 17.5927 2.03124 16.967 2.17848L16.967 2.17848L16.9345 2.18611L11.9121 3.36787L11.8686 3.37809C11.1658 3.54343 10.5739 3.68269 10.1073 3.85356C9.61205 4.03492 9.17811 4.27863 8.84424 4.70018C8.51037 5.12173 8.37252 5.59995 8.30941 6.12357C8.24995 6.6169 8.24997 7.225 8.25 7.94701L8.25 7.99161V9.00002V15.9997C7.62325 15.529 6.8442 15.25 6 15.25C3.92893 15.25 2.25 16.9289 2.25 19C2.25 21.0711 3.92893 22.75 6 22.75C8.07107 22.75 9.75 21.0711 9.75 19V9.5856L20.25 6.9606Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMusicNote2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Music Note - 2.7ec50160cb75d8ee96f34b3fb75e51be.svg";